import styled from 'styled-components'

export const Wrapper = styled.div`
  flex: 1;
  max-width: 660px;
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`
